import Config from '../utils/Config.js';

export default class Utils
{
    static formatMoney(num = 0)
    {
        let {
            prefix, suffix,
            groupingSeparator, decimalSeparator,
            decimalPlaces
            } = Config.CURRENCY;

        num = num || 0;
        num = Math.floor(num * 100) / 100;
        let numStr = num.
            toFixed(decimalPlaces)
            .replace('.', decimalSeparator)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${groupingSeparator}`);
        return `${prefix || ''}${numStr}${suffix || ''}`;
    }

    static queryParse(string = window.location.search)
    {
        string = string || '?';
        let s = string.split(/\?/, 2).pop();

        if (!s || s.length <= 1)
        {
            return {};
        }

        let obj = {};
        const chunks = s.split('&');
        for (let i = 0, len = chunks.length; i < len; i++)
        {
            let chunk = chunks[i];
            chunk = chunk.split('=', 2);
            let key = chunk[0];
            let value = chunk[1];
            if (!key)
            {
                continue;
            }
            key = key.trim();
            value = decodeURIComponent(value);
            obj[key] = value;
        }

        return obj;
    }

    static combinate()
    {
        let r = [];
        let arg = arguments;
        let max = arg.length - 1;

        function helper(arr, i)
        {
            for (let j = 0, l = arg[i].length; j < l; j++)
            {
                let a = arr.slice(0);
                a.push(arg[i][j]);
                if (i === max)
                {
                    r.push(a);
                }
                else
                {
                    helper(a, i + 1);
                }
            }
        }

        helper([], 0);
        return r;
    }

    static textToDOM(xmlStr)
    {
        xmlStr = '<wrapper>' + xmlStr + '</wrapper>';
        if (typeof window.DOMParser != 'undefined')
        {
            return (new window.DOMParser()).parseFromString(xmlStr, 'text/xml');
        }
        else if (typeof window.ActiveXObject != 'undefined' &&
            new window.ActiveXObject('Microsoft.XMLDOM'))
        {
            let xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
            xmlDoc.async = 'false';
            xmlDoc.loadXML(xmlStr);
            return xmlDoc;
        }
        else
        {
            throw new Error('No XML parser found');
        }
    }

    static setFormattedText(textfield, text, inlineParams)
    {
        let preparedText = Object
            .entries(inlineParams)
            .reduce((text, param) => text.replace(`%${param[0]}%`, param[1]), text);

        let messageDoc = Utils.textToDOM(preparedText);

        let rawText = messageDoc.childNodes[0].innerHTML;
        let nodes = messageDoc.childNodes[0].childNodes;
        let styles = [];

        for (let i = 0, len = nodes.length; i < len; i++)
        {
            let node = nodes[i];
            switch(node.nodeType)
            {
                case Node.ELEMENT_NODE:
                {
                    if (!/style/i.test(node.tagName))
                    {
                        break;
                    }

                    let rawBlock = node.outerHTML;
                    let content = node.innerHTML;
                    let style = {
                        color: node.getAttribute('color') || 'white',
                        fontStyle: node.getAttribute('fontStyle') || 'normal',
                        fontSize: node.getAttribute('fontSize') || textfield.fontSize,
                        startPosition: rawText.indexOf(rawBlock),
                        content: content
                    };
                    rawText = rawText.replace(rawBlock, content);
                    styles.push(style);
                }
                    break;

                case Node.TEXT_NODE:
                {
                    let rawBlock = node.textContent;
                    let style = {
                        color: 'white',
                        fontStyle: 'normal',
                        startPosition: rawText.indexOf(rawBlock),
                        content: rawBlock
                    };
                    styles.push(style);
                }
                    break;
            }
        }

        const colors = {
            red: '#bd2800',
            white: '#ffffff',
            yellow: '#ffcd31'
        };

        textfield.text = rawText;
        styles.forEach((style) =>
        {
            textfield.addColor(colors[style.color] || colors.white, style.startPosition);
            textfield.addFontWeight(style.fontStyle || 'normal', style.startPosition);
        });

        return textfield;
    }

    static makeMatrix(rows = 4, cols = 4, initialValue)
    {
        let matrix = new Array(rows);
        for (let rowIndex = 0; rowIndex < rows; rowIndex++)
        {
            let row = matrix[rowIndex] = matrix[rowIndex] || new Array(cols);
            for (let colIndex = 0; colIndex < cols; colIndex++)
            {
                row[colIndex] = initialValue;
            }
        }
        return matrix;
    }

    static makeTimeoutPromise(time)
    {
        return new Promise((res) =>
        {
            setTimeout(() => res(Promise.resolve()), time);
        });
    }

    /*
    * suppress LeanderAPI console.log calls
    * */
    static leanderAPILogsEnabled(value)
    {
        if (LeanderUtils && LeanderUtils.debugConsoleLog)
        {
            LeanderUtils.debugConsoleLog.enabled = LeanderUtils.logEnabled = LeanderUtils.debugConsoleLog.logInternalMessages = !!value;
        }

        if (leanderCasinoManager)
        {
            leanderCasinoManager.logEnabled = !!value;
        }
    }
    
    static getSymbolByIndex( index, slotIndex=0, cellIndex=0 )
    {
        //return ['bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib','guy', 'singer', 'old'][index-1];   
        return {
            symbol: ['bonus','singer','guy','old','diamond','raki','ring','microphone','glasses','teshib'][(index-1)%10],
            type: 'regular', //( index>10? 'extra': 'regular' ),
            slotIndex: slotIndex,
            cellIndex: cellIndex
        }
    }
    
    static findCellModel( cellModels, slot, cell )
    {
        for( let ii=0; ii<cellModels.length; ++ii ) 
            if( cellModels[ii].slotIndex === slot && cellModels[ii].cellIndex === cell ) return cellModels[ii];
        return null;
    }
    
    static getHighlightedReels( reelLayout, symbol )
    {
        let highlightedReels = [];
        
        let c = 0;
        let ii = 0;            
        for( ii=0; ii<4; ++ii ) // at least one need to highlight
        {                
            for( let jj=0; jj<3; ++jj )
            {
                if( reelLayout[jj*5+ii] === symbol ) 
                {
                    ++c;
                    break;
                }
            }
            if( c >= 2 ) break; 
        }
        for( let jj=ii+1; jj<5; ++jj )
            highlightedReels.push(jj);        
        
        return highlightedReels; 
    }
}